'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropertyType = undefined;

var _types = require('ui-addon-upgrades/_core/common/data/upgradeData/properties/types');

var _createProperty = require('ui-addon-upgrades/_core/common/data/upgradeData/transformers/createProperty');

var PROPERTY_KEY = 'type';

/**
 * @param {Object} upgradeData
 * @param {String} upgradeSource
 * @return {Object}
 */

var getPropertyType = exports.getPropertyType = function getPropertyType(upgradeData, upgradeSource) {
  var propertyValue = _types.types[upgradeSource];

  return (0, _createProperty.createProperty)(PROPERTY_KEY, propertyValue);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/data/upgradeData/transformers/getPropertyType.js
// module id = 447
// module chunks = 3 4 5